query getPageSeoData($page: String) {
  pageSeoData(page: $page) {
    metaTitle
    metaDescription
    seoText
    seoTitle
    h1
    ogTitle
    ogDescription
  }
}
